import { useIntl } from '@redbubble/next/intl';
import {
  differenceInDays,
  differenceInHours,
  intlFormat,
  intlFormatDistance,
} from 'date-fns';
import { couponMessages } from '../messages';

export const useDateRangeMessage = (locale: string, start: Date, end: Date) => {
  const intl = useIntl();
  const intervalHours = differenceInHours(end, start);

  if (intervalHours <= 1)
    return intl.formatMessage(couponMessages.expiresThisHour);

  if (intervalHours < 36)
    return intl.formatMessage(couponMessages.expiresInDaysOrHours, {
      expiresIn: intlFormatDistance(end, start, { unit: 'hour', locale }),
    });

  const intervalDays = differenceInDays(end, start);

  if (intervalDays < 11)
    return intl.formatMessage(couponMessages.expiresInDaysOrHours, {
      expiresIn: intlFormatDistance(end, start, { unit: 'day', locale }),
    });

  return intl.formatMessage(couponMessages.expiresOnDate, {
    expiresOn: [
      intlFormat(end, { day: '2-digit' }, { locale }),
      intlFormat(end, { month: 'long' }, { locale }),
      intlFormat(end, { year: 'numeric' }, { locale }),
    ].join(' '),
  });
};
